export class MenuConfig {
    public defaults: any = {
        header: {
            self: {},
            items: [
                {
                    title: 'Dashboards',
                    root: true,
                    alignment: 'left',
                    page: '/dashboard',
                    translate: 'MENU.DASHBOARD',
                },
                {
                    title: 'Applications',
                    root: true,
                    alignment: 'left',
                    toggle: 'click',
                    submenu: [
                        {
                            title: 'eCommerce',
                            bullet: 'dot',
                            icon: 'flaticon-business',
                            permission: 'accessToECommerceModule',
                            submenu: [
                                {
                                    title: 'Customers',
                                    page: '/ecommerce/customers',
                                },
                                {
                                    title: 'Products',
                                    page: '/ecommerce/products',
                                },
                            ],
                        },
                        {
                            title: 'Kullanıcı Yönetimi',
                            bullet: 'dot',
                            icon: 'flaticon-user',
                            submenu: [
                                {
                                    title: 'Kullanıcılar',
                                    page: '/user-management/users',
                                },
                                {
                                    title: 'Roller',
                                    page: '/user-management/roles',
                                },
                            ],
                        },
                    ],
                },
                {
                    title: 'Custom',
                    root: true,
                    alignment: 'left',
                    toggle: 'click',
                    submenu: [
                        {
                            title: 'Error Pages',
                            bullet: 'dot',
                            icon: 'flaticon2-list-2',
                            submenu: [
                                {
                                    title: 'Error 1',
                                    page: '/error/error-v1',
                                },
                                {
                                    title: 'Error 2',
                                    page: '/error/error-v2',
                                },
                                {
                                    title: 'Error 3',
                                    page: '/error/error-v3',
                                },
                                {
                                    title: 'Error 4',
                                    page: '/error/error-v4',
                                },
                                {
                                    title: 'Error 5',
                                    page: '/error/error-v5',
                                },
                                {
                                    title: 'Error 6',
                                    page: '/error/error-v6',
                                },
                            ],
                        },
                        {
                            title: 'Wizard',
                            bullet: 'dot',
                            icon: 'flaticon2-mail-1',
                            submenu: [
                                {
                                    title: 'Wizard 1',
                                    page: '/wizard/wizard-1',
                                },
                                {
                                    title: 'Wizard 2',
                                    page: '/wizard/wizard-2',
                                },
                                {
                                    title: 'Wizard 3',
                                    page: '/wizard/wizard-3',
                                },
                                {
                                    title: 'Wizard 4',
                                    page: '/wizard/wizard-4',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        aside: {
            self: {},
            items: [
                {
                    title: 'Anasayfa',
                    root: true,
                    icon: 'flaticon2-architecture-and-city',
                    page: '/home',
                    translate: 'MENU.DASHBOARD',
                    bullet: 'dot',
                },
                {
                    title: 'Layout Builder',
                    root: true,
                    icon: 'flaticon2-expand',
                    page: '/builder',
                    permission: 'accessToECommerceModule',
                },
                // { section: 'Applications' },
                {
                    title: 'eCommerce',
                    bullet: 'dot',
                    icon: 'flaticon2-list-2',
                    root: true,
                    permission: 'accessToECommerceModule',
                    submenu: [
                        {
                            title: 'Customers',
                            page: '/ecommerce/customers',
                        },
                        {
                            title: 'Products',
                            page: '/ecommerce/products',
                        },
                    ],
                },
                {
                    title: 'Kullanıcı Yönetimi',
                    root: true,
                    bullet: 'dot',
                    icon: 'flaticon2-user-outline-symbol',
                    permission: ['GetUsers', 'GetRoles'],
                    submenu: [
                        {
                            title: 'Kullanıcılar',
                            page: '/user-management/users',
                            permission: 'GetUsers',
                        },
                        {
                            title: 'Roller',
                            page: '/user-management/roles',
                            permission: 'GetRoles',
                        },
                    ],
                },
                {
                    title: 'Kariyer Yönetimi',
                    root: true,
                    bullet: 'dot',
                    icon: 'flaticon2-layers-1',
                    permission: ['GetEducationInformations', 'GetWorkExperiences'],
                    submenu: [
                        {
                            title: 'Eğitim Bilgileri',
                            page: '/career-management/education-informations',
                            permission: 'GetEducationInformations',
                        },
                        {
                            title: 'İş Deneyimleri',
                            page: '/career-management/work-experiences',
                            permission: 'GetWorkExperiences',
                        },
                        {
                            title: 'Sertifika Bilgileri',
                            page: '/career-management/certificate-informations',
                            permission: 'GetCertificateInformations',
                        },
                        {
                            title: 'Staj Bilgileri',
                            page: '/career-management/internship-informations',
                            permission: 'GetInternshipInformations',
                        },
                        {
                            title: 'Yabancı Dil Bilgileri',
                            page: '/career-management/foreign-language-informations',
                            // permission: 'GetForeignLanguageInformations',
                        },
                    ],
                },
                {
                    title: 'Mezun Kart İşlemleri',
                    root: true,
                    bullet: 'dot',
                    icon: 'flaticon-profile',
                    permission: ['GetCardApplications', 'GetAllCardApplications'],
                    submenu: [
                        {
                            title: 'Kart Başvurularım',
                            page: '/card-applications/my-card-applications',
                            permission: 'GetCardApplications',
                        },
                        {
                            title: 'Kart Başvuruları',
                            page: '/card-applications/all-card-applications',
                            permission: 'GetAllCardApplications',
                        },
                    ],
                },
                {
                    title: 'E-Devlet İşlemleri',
                    root: true,
                    bullet: 'dot',
                    page: '/edevlet-transactions',
                    icon: 'flaticon-squares-3'
                },
                {
                    title: 'Sistem',
                    root: true,
                    bullet: 'dot',
                    icon: 'flaticon2-dashboard',
                    permission: ['GetLogs'],
                    submenu: [
                        {
                            title: 'İstatistik',
                            page: '/system/statistics',
                            permission: 'GetLogs',
                        },
                        {
                            title: 'Log Kayıtları',
                            page: '/system/logs',
                            permission: 'GetLogs',
                        },
                        {
                            title: 'Ziyaretçi Etkinliği',
                            page: '/system/user-activity',
                            permission: 'GetLogs',
                        },
                    ],
                },
                // { section: 'Custom', permission: 'custom' },
                {
                    title: 'Error Pages',
                    root: true,
                    bullet: 'dot',
                    icon: 'flaticon2-list-2',
                    permission: 'error',
                    submenu: [
                        {
                            title: 'Error 1',
                            page: '/error/error-v1',
                        },
                        {
                            title: 'Error 2',
                            page: '/error/error-v2',
                        },
                        {
                            title: 'Error 3',
                            page: '/error/error-v3',
                        },
                        {
                            title: 'Error 4',
                            page: '/error/error-v4',
                        },
                        {
                            title: 'Error 5',
                            page: '/error/error-v5',
                        },
                        {
                            title: 'Error 6',
                            page: '/error/error-v6',
                        },
                    ],
                },
                {
                    title: 'Wizard',
                    root: true,
                    bullet: 'dot',
                    icon: 'flaticon2-mail-1',
                    permission: 'accessToECommerceModule',
                    submenu: [
                        {
                            title: 'Wizard 1',
                            page: '/wizard/wizard-1',
                        },
                        {
                            title: 'Wizard 2',
                            page: '/wizard/wizard-2',
                        },
                        {
                            title: 'Wizard 3',
                            page: '/wizard/wizard-3',
                        },
                        {
                            title: 'Wizard 4',
                            page: '/wizard/wizard-4',
                        },
                    ],
                },
            ],
        },
    };

    public get configs(): any {
        return this.defaults;
    }
}
